import React from "react";

export default function ArrowDownIcon() {
  return (
    <svg
      width="24"
      height="13"
      viewBox="0 0 24 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0L12 12.4752L24 0H0Z" fill="#00BE9A" />
    </svg>
  );
}
